module.exports = __webpack_public_path__ + "static/media/logo-award-trustradius-top-rated-2022.c38e345c.png";